import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Money } from '../../Components/Form';
import { useBalance } from '../../Data/Balance';
import { PageLoading } from '../../Components/Loading';
import MoneyFormat from '../../Components/Formatting/Money';

const TopUp = ({isOpen, setIsOpen, onComplete}) => {
    return <Modal title="Top up" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner after={onComplete} />}
    </Modal>
}

const Inner = ({after}) => {
    const {balance, topUp} = useBalance(true);

    if (!balance) {
        return <PageLoading />
    }

    const handleSubmit = (data) => {
        return topUp(data.amount, 'Manual topup');
    }

    return <Form data={{amount: Math.abs(balance.retainedPence ?? 0)}}
            onSubmit={handleSubmit}
            afterSubmit={after}
            closeModalOnSubmit
        >
        <Money name="amount" label="Amount" />

        <p>Your current balance is <MoneyFormat pence={balance.retainedPence} colour symbol /></p>

        <Actions submit={{label: 'Top up'}} cancel />
    </Form>
}

export default TopUp;
